module.exports = __webpack_public_path__ + "img/IAR3.a08eea70.png";